export const mainCategories = [
  {
    key: "locations",
    title: "Locations",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-locations.svg",
  },
  {
    key: "photography",
    title: "Fotografen",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "videography",
    title: "Videografen",
    iconUrl: "	https://www.weddyplace.com/assets/svg/icon-videography.svg",
  },
  {
    key: "planning",
    title: "Hochzeitsplaner",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-planning.svg",
  },
  {
    key: "catering",
    title: "Catering",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-cakes.svg",
  },
  {
    key: "music",
    title: "Musik",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-music.svg",
  },
  {
    key: "florists", //
    title: "Floristen",
    // iconUrl: "https://www.weddyplace.com/assets/svg/icon-cakes.svg",
  },
  {
    key: "bridalwear",
    title: "Brautkleider",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-music.svg",
  },
  {
    key: "cakes",
    title: "Hochzeitstorten",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-cakes.svg",
  },
  {
    key: "officiants",
    title: "Trauredner",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "styling",
    title: "Styling",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  // Papeterie is temporarily hidden. Restore this entry from Git when it returns.

  {
    key: "bachelor",
    title: "Junggesellenabschied",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "cars",
    title: "Autoverleih",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "church",
    title: "Kirchen",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "civil",
    title: "Standesämter",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "deko",
    title: "Dekoration",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "entertainment",
    title: "Entertainment",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "gift",
    title: "Geschenke",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "jewelry",
    title: "Trauringe",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "photobox",
    title: "Fotobox",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
  {
    key: "honeymoon",
    title: "Flitterwochen",
    iconUrl: "https://www.weddyplace.com/assets/svg/icon-photography.svg",
  },
];

export const locationCategories = [
  {
    key: "berlin",
    title: "Berlin",
    lat: 52.52000659999999,
    lng: 13.404954,
  },
  {
    key: "hamburg",
    title: "Hamburg",
    lat: 53.5510846,
    lng: 9.9936818,
  },
  {
    key: "muenchen",
    title: "München",
    lat: 48.1351253,
    lng: 11.5819806,
  },
  {
    key: "koln",
    title: "Köln",
    lat: 50.937531,
    lng: 6.9602786,
  },
  {
    key: "stuttgart",
    title: "Stuttgart",
    lat: 48.7758459,
    lng: 9.1829321,
  },
  {
    key: "dusseldorf",
    title: "Düsseldorf",
    lat: 51.22774,
    lng: 6.7734556,
  },
  {
    key: "dortmund",
    title: "Dortmund",
    lat: 51.5135872,
    lng: 7.465298100000001,
  },
  {
    key: "essen",
    title: "Essen",
    lat: 51.4556432,
    lng: 7.0115552,
  },
  {
    key: "leipzig",
    title: "Leipizig",
    lat: 51.3396955,
    lng: 12.3730747,
  },
  {
    key: "bremen",
    title: "Bremen",
    lat: 53.07929619999999,
    lng: 8.8016937,
  },
  {
    key: "dresden",
    title: "Dresden",
    lat: 51.0504088,
    lng: 13.7372621,
  },
  {
    key: "hannover",
    title: "Hannover",
    lat: 52.3758916,
    lng: 9.732010400000002,
  },
  {
    key: "nurnberg",
    title: "Nürnberg",
    lat: 49.4521018,
    lng: 11.0766654,
  },
  {
    key: "duisburg",
    title: "Duisburg",
    lat: 51.4344079,
    lng: 6.762329299999999,
  },
  {
    key: "bonn",
    title: "Bonn",
    lat: 50.73743,
    lng: 7.0982068,
  },
  {
    key: "augsburg",
    title: "Augsburg",
    lat: 48.3705449,
    lng: 10.89779,
  },
  {
    key: "wien",
    title: "Wien",
    lat: 48.2081743,
    lng: 16.3738189,
  },
  {
    key: "zurich",
    title: "Zürich",
    lat: 47.3768866,
    lng: 8.541694,
  },
];

export const capacityOptions = [
  { key: "20", text: "20 Gäste" },
  { key: "40", text: "40 Gäste" },
  { key: "60", text: "60 Gäste" },
  { key: "80", text: "80 Gäste" },
  { key: "100", text: "100 Gäste" },
  { key: "120", text: "120 Gäste" },
  { key: "140", text: "140 Gäste" },
  { key: "200", text: "200 Gäste" },
  { key: "500", text: "500 Gäste" },
  { key: "1000", text: "1000 Gäste" },
];

export const budgetEnds = [
  { key: "1.000€", value: 1000 },
  { key: "2.000 €", value: 2000 },
  { key: "3.000 €", value: 3000 },
  { key: "4.000 €", value: 4000 },
  { key: "5.000 €", value: 5000 },
  { key: "6.000 €", value: 6000 },
  { key: "7.000 €", value: 7000 },
  { key: "8.000 €", value: 8000 },
  { key: "9.000 €", value: 9000 },
  { key: "10.000 €", value: 10000 },
  { key: "11.000 €", value: 11000 },
  { key: "12.000 €", value: 12000 },
  { key: "13.000 €", value: 13000 },
  { key: "14.000 €", value: 14000 },
  { key: "15.000 €", value: 15000 },
  { key: "16.000 €", value: 16000 },
  { key: "17.000 €", value: 17000 },
  { key: "18.000 €", value: 18000 },
  { key: "19.000 €", value: 19000 },
  { key: "20.000 €", value: 20000 },
  { key: "21.000 €", value: 21000 },
  { key: "22.000 €", value: 22000 },
  { key: "23.000 €", value: 23000 },
  { key: "24.000 €", value: 24000 },
  { key: "25.000 €", value: 25000 },
];
